<template>
  <div>
    <div class="row customFieldControl" v-if="labelPosition === 'left'">
      <div class="col-md-4">
        <label
          class="form-control-label"
          :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
        >{{control.label}}</label>
      </div>
      <div class="col-md-8">
        <DynamicRender
          v-if="loaded && (widgetsData && widgetsComputedReady)"
          :template="control.customCode || ''"
          :data="widgetsData"
          :computed="widgetsComputedReady"
        />
      </div>
    </div>
    <div v-else>
      <label
        class="form-control-label"
        :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
      >{{control.label}}</label>
      <div>
        <DynamicRender
          v-if="loaded && (widgetsData && widgetsComputedReady)"
          :template="control.customCode || ''"
          :data="widgetsData"
          :computed="widgetsComputedReady"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// components
import DynamicRender from '@/components/DynamicRender'
// services
import db from '@/services/db'
// helpers
import eventBus from '@/helpers/event-bus'

export default {
  props: ['control', 'labelPosition'],
  components: {
    DynamicRender,
  },
  data() {
    return {
      loaded: false,
      gridId: null,
      rowKey: null,
      widgetsData: null,
      widgetsComputedReady: null,
    }
  },
  methods: {
    updateCell() {
      this.loaded = false
      this.widgetsData.rowData = $dataGrid(this.gridId)[this.rowKey]
      setTimeout(() => {
        this.loaded = true
      }, 100)
    },
  },
  created() {
    this.$nextTick(() => {
      const { gridId, rowKey } = this.$instByClass(this, 'form-builder-root')

      this.gridId = gridId
      this.rowData = rowKey

      const dInst = this.$instByClass(this, 'dashboard-component')
      this.widgetsData = Object.assign(
        { control: this.control },
        dInst.widgetsData
      )
      this.widgetsComputedReady = dInst.widgetsComputedReady

      this.widgetsData.rowData = $dataGrid(gridId)[rowKey]
      eventBus.$on(`dgRowUpdated-${gridId}`, this.updateCell)
      this.widgetsData.gridId = gridId
      this.widgetsData.rowKey = rowKey

      this.loaded = true
    })
  },
  beforeDestroy() {
    eventBus.$off(`dgRowUpdated-${this.gridId}`, this.updateCell)

    this.widgetsData = null
    this.widgetsComputedReady = null
    this.loaded = null
  }
}
</script>
